module.exports = __webpack_public_path__ + "img/14.bf0741a5.jpg";